export default {"src":"/_next/static/media/dog-owner-purple.90a0a9bd.svg","height":78,"width":78,"blurWidth":0,"blurHeight":0};